/**
 * CSP Sticky Buy Mobile
 * Makes buy section (variants + buy buttons) sticky on mobile when user scrolls past the sentinel
 * Once sticky, it stays sticky (never goes back to normal)
 */
(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const sentinel = document.querySelector(
      ".csp-product-page [data-buy-sentinel]"
    );
    const buySection = document.querySelector(
      ".csp-product-page [data-product-buy-section]"
    );

    if (!sentinel || !buySection) return;

    // Only on mobile
    function isMobile() {
      return window.innerWidth <= 749;
    }

    if (!isMobile()) return;

    let isSticky = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // When sentinel enters viewport from bottom (we've scrolled to the section)
          // OR when sentinel leaves viewport from top (we've scrolled past the section)
          if (entry.isIntersecting) {
            // Check if section bottom is at or above viewport bottom
            const sectionRect = buySection.getBoundingClientRect();
            const viewportBottom = window.innerHeight;

            // If section bottom reaches viewport bottom, make it sticky
            if (sectionRect.bottom <= viewportBottom && !isSticky) {
              buySection.classList.add("is-sticky");
              isSticky = true;
            }
          } else if (entry.boundingClientRect.top < 0 && !isSticky) {
            // Sentinel has left viewport from top - section should be sticky
            buySection.classList.add("is-sticky");
            isSticky = true;
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1],
      }
    );

    observer.observe(sentinel);

    // Also check on scroll for more precise detection
    function checkSticky() {
      if (isSticky || !buySection) return;

      const sectionRect = buySection.getBoundingClientRect();
      const viewportBottom = window.innerHeight;

      // When section bottom reaches viewport bottom, make it sticky
      if (sectionRect.bottom <= viewportBottom) {
        buySection.classList.add("is-sticky");
        isSticky = true;
        window.removeEventListener("scroll", checkSticky);
        observer.disconnect();
      }
    }

    window.addEventListener("scroll", checkSticky, { passive: true });
    checkSticky(); // Initial check

    // Handle resize - disable sticky on desktop
    window.addEventListener(
      "resize",
      () => {
        if (!isMobile() && isSticky) {
          buySection.classList.remove("is-sticky");
          isSticky = false;
        }
      },
      { passive: true }
    );
  }
})();
